<div class="pb-5 px-md-5 mt-md-5">
  <h2 class="text-info mb-4" *ngIf="type == 'BANK'">Voici la liste des banques engagées avec Opale :</h2>
  <div class="row g-4">
    <div class="col-12 col-lg-4" *ngFor="let partner of partners">
      <div class="card-partner">
        <img [src]="partner.image | companyImage" class="partner-logo" [alt]="partner.name" *ngIf="partner.image">
        <p class="partner-name">{{partner.name}}</p>
        <p class="card-resource-text text-center" style="flex-grow: 1">{{ partner.summary }}</p>
        <button class="btn btn-info text-white fw-semibold px-4 mt-auto" style="border-radius: 10px" (click)="openModalPartner(partner)">Plus d'informations</button>
      </div>
    </div>
  </div>
</div>
